export class PatientDto {
    public  id:number;
    public  firstName:string;
    public  middleName:string;
    public  lastName:string;
    public  fullName:string;
    public  firstNameEn:string;
    public  middleNameEn:string;
    public  lastNameEn:string;
    public  email:string;
    public  password:string;
    public  birthDate:string;
    public  gender:string;
    public  nationality:string;
    public  workPlace:string;
    public  country:string;
    public  city:string;
    public  neighborhood:string;
    public  address:string;
    public  phoneNumber:string;
    public  countryPhoneCode:string;
    public  idCardNumber:string;
    public  userId:string;
    public  type:string='R';
    public  occupation:string;

}
